import styled from "styled-components";

interface Props {
    menuOpen?: boolean;
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: fit-content;
    position: relative;
    margin: 0 auto;
    overflow-x: visible;
    box-sizing: border-box;

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 50%;
        margin-top: 200px;
        transform: translateX(-50%);
    }

    .planos-top-actions {
        display: flex;
        gap: 12px;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 16px;
        box-sizing: border-box;
        min-width: 0;

        @media (max-width: 992px) {
            width: 100%;
            min-width: 0;
        }
        
        @media (max-width: 768px) {
            margin: 0 0 16px 0;
            gap: 8px;
        }
        
        &:empty {
            margin-bottom: 0;
            display: none;
        }
    }

    .op {
        position: absolute;
        width: fit-content;
        right: 0;
        margin-top: -72px;
        padding: 16px;
        z-index: 1001;
    }

    .planos-top-actions > * {
        position: relative;
        margin-top: 0;
    }

    .zero {
        color: ${({ theme }) => theme.colors.interfaceText400};
        text-align: center;
        width: 100%;
        padding: 24px 0;
    }
`;

export const Menu = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 12px;
    min-width: 0;
    box-sizing: border-box;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        min-width: 0;
        width: 100%;
        margin: 0 0 24px 0;
        gap: 8px;
    }
`;

export const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const PlanoCard = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-shadow: 35px 45px 73px rgba(32, 32, 35, 0.07);
`;

/* Desktop: esconde no mobile */
export const PlanoCardDesktop = styled.div`
    width: 100%;
    @media (max-width: 768px) {
        display: none !important;
    }
`;

/* Mobile: card vertical colapsado (visível só em telas pequenas) */
export const PlanoCardMobile = styled.div`
    display: none;
    width: 100%;
    background: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(32, 32, 35, 0.08);
    flex-direction: column;
    gap: 12px;

    @media (max-width: 768px) {
        display: flex;
    }

    .mobile-title {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 2px;
    }
    .mobile-value {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 14px;
        font-weight: 500;
    }
    .mobile-name {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-weight: 500;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        min-width: 0;
    }
    .mobile-credits {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 14px;
        font-weight: 500;
    }
`;

export const PlanoCardMobileTop = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;

    .mobile-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        svg path { fill: ${({ theme }) => theme.colors.interfaceGray300}; }
    }
    .mobile-name-credits {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
    .mobile-badge-wrap {
        margin-left: auto;
        flex-shrink: 0;
    }
`;

export const PlanoCardMobileRow = styled.div`
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex-wrap: wrap;
`;

export const PlanoCardMobileDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid ${({ theme }) => theme.colors.interfacePure100};
`;

export const PlanoCardMobileDetailItem = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    .mobile-title { margin-bottom: 2px; }
`;

export const PlanoCardMobileActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding-top: 8px;
    border-top: 1px solid ${({ theme }) => theme.colors.interfacePure100};

    .link-abrir-mobile {
        flex: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 40px;
        padding: 0 16px;
        background: ${({ theme }) => theme.colors.interfaceGray300};
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.interfacePure0};
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;
        &:hover { background: ${({ theme }) => theme.colors.interfaceGray400}; color: ${({ theme }) => theme.colors.interfacePure0}; }
    }
    .arrow-btn-mobile {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: ${({ theme }) => theme.colors.interfacePure0};
        border: 1px solid ${({ theme }) => theme.colors.interfaceGray300};
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        cursor: pointer;
        flex-shrink: 0;
        transition: border-color 0.2s, color 0.2s;
        &:hover {
            border-color: ${({ theme }) => theme.colors.interfaceGray400};
            color: ${({ theme }) => theme.colors.interfaceGray500};
        }
    }
`;

export const PlanoWrapper = styled.div<Props>`
    display: grid;
    grid-template-columns: 80px 1.5fr 1.2fr 1.2fr 1.2fr 72px 180px;
    grid-template-rows: 80px ${({ menuOpen }) => (menuOpen ? "80px" : "0px")};
    width: 100%;
    min-width: 800px;

    @media (max-width: 768px) {
        display: none !important;
    }
    min-height: 80px;
    height: ${({ menuOpen }) => (menuOpen ? "160px" : "80px")};
    background: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 8px;
    padding-left: 24px;
    padding-right: 16px;
    overflow: visible;
    gap: 0 24px;

    /* Telas médias-grandes */
    @media (min-width: 1200px) and (max-width: 1399px) {
        grid-template-columns: 70px 1.5fr 1.2fr 1.2fr 1.2fr 72px 170px;
        gap: 0 20px;
        min-width: 800px;
    }

    /* Telas médias */
    @media (min-width: 900px) and (max-width: 1199px) {
        grid-template-columns: 60px 1.5fr 1fr 1fr 1fr 64px 140px;
        gap: 0 12px;
        min-width: 750px;
        padding-left: 16px;
        padding-right: 12px;
    }

    /* Telas pequenas */
    @media (min-width: 600px) and (max-width: 899px) {
        grid-template-columns: 50px 1.5fr 1fr 1fr 1fr 64px 130px;
        gap: 0 8px;
        min-width: 600px;
        padding-left: 12px;
        padding-right: 8px;
    }

    /* Telas muito pequenas */
    @media (max-width: 599px) {
        grid-template-columns: 40px 1.5fr 1fr 1fr 1fr 56px 120px;
        gap: 0 6px;
        min-width: 530px;
        padding-left: 8px;
        padding-right: 6px;
        font-size: 13px;
    }

    .title {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .subtitle {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 14px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .plano-name {
        width: 100%;
        max-width: 100%;
        overflow: hidden;
    }
    .plano-name .subtitle {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-weight: 500;
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .status-col {
        display: flex;
        align-items: center;
    }
`;

export const PlanoTop = styled.div`
    grid-row: 1;
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: 80px 1.5fr 1.2fr 1.2fr 1.2fr 72px 180px;
    gap: 0 24px;
    align-items: center;
    min-height: 80px;

    & > *:nth-child(1) { grid-column: 1; }
    & > *:nth-child(2) { grid-column: 2; }
    & > *:nth-child(3) { grid-column: 3; }
    & > *:nth-child(4) { grid-column: 4; }
    & > *:nth-child(5) { grid-column: 5; }
    & > *:nth-child(6) { grid-column: 6; }
    & > *:nth-child(7) { grid-column: 7; }

    /* Telas médias-grandes */
    @media (min-width: 1200px) and (max-width: 1399px) {
        grid-template-columns: 70px 1.5fr 1.2fr 1.2fr 1.2fr 72px 170px;
        gap: 0 20px;
    }

    /* Telas médias */
    @media (min-width: 900px) and (max-width: 1199px) {
        grid-template-columns: 60px 1.5fr 1fr 1fr 1fr 64px 140px;
        gap: 0 12px;
    }

    /* Telas pequenas */
    @media (min-width: 600px) and (max-width: 899px) {
        grid-template-columns: 50px 1.5fr 1fr 1fr 1fr 64px 130px;
        gap: 0 8px;
    }

    /* Telas muito pequenas */
    @media (max-width: 599px) {
        grid-template-columns: 40px 1.5fr 1fr 1fr 1fr 56px 120px;
        gap: 0 6px;
    }
`;

export const PlanoBottom = styled.div<Props>`
    grid-row: 2;
    grid-column: 1 / -1;
    display: ${({ menuOpen }) => (menuOpen ? "grid" : "none")};
    grid-template-columns: 80px 1.5fr minmax(160px, 1.2fr) 1.2fr 1.2fr 72px 180px;
    gap: 0 24px;
    align-items: center;
    min-height: 80px;

    & > *:nth-child(1) { grid-column: 1; }
    & > *:nth-child(2) { grid-column: 2; }
    & > *:nth-child(3) { grid-column: 3; }
    & > *:nth-child(4) { grid-column: 4; }

    /* Telas médias-grandes */
    @media (min-width: 1200px) and (max-width: 1399px) {
        grid-template-columns: 70px 1.5fr minmax(160px, 1.2fr) 1.2fr 1.2fr 72px 170px;
        gap: 0 20px;
    }

    /* Telas médias */
    @media (min-width: 900px) and (max-width: 1199px) {
        grid-template-columns: 60px 1.5fr minmax(160px, 1fr) 1fr 1fr 64px 140px;
        gap: 0 12px;
    }

    /* Telas pequenas */
    @media (min-width: 600px) and (max-width: 899px) {
        grid-template-columns: 50px 1.5fr minmax(160px, 1fr) 1fr 1fr 64px 130px;
        gap: 0 8px;
    }

    /* Telas muito pequenas */
    @media (max-width: 599px) {
        grid-template-columns: 40px 1.5fr minmax(150px, 1fr) 1fr 1fr 56px 120px;
        gap: 0 6px;
    }
`;

export const DivIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        path {
            fill: ${({ theme }) => theme.colors.interfaceGray300};
        }
    }
`;

export const DivIconSpacer = styled.div``;

export const DivCol = styled.div<{ width?: string; minWidth?: string }>`
    min-width: ${({ minWidth }) => minWidth || "0"};
    max-width: ${({ width }) => width || "none"};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
`;

export const DivActionsRight = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 9px;
    min-width: 120px;
    flex-shrink: 0;
`;

export const DivArrow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 40px;
    cursor: pointer;
    flex-shrink: 0;
`;

export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
    max-width: 72px;

    &.success {
        background-color: ${({ theme }) => theme.colors.interfaceSuccess100};
        color: ${({ theme }) => theme.colors.interfaceSuccess400};
    }

    &.default {
        background-color: ${({ theme }) => theme.colors.interfacePure100};
        color: ${({ theme }) => theme.colors.interfaceText500};
    }
`;

/* Botões no padrão da página de Demandas */
export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1.25rem;
  border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.primaryRed400};
  color: ${({ theme }) => theme.colors.pureWhite};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;

  svg {
    min-width: 19px;
    min-height: 19px;
    width: 19px;
    height: 19px;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    padding: 0 1rem;
    font-size: 0.8125rem;
    flex: 1;
    min-width: 0;
    /* Garante que o botão não quebre o layout */
    max-width: 100%;
    
    @media (max-width: 420px) {
      padding: 0 0.75rem;
      font-size: 0.75rem;
    }
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1rem;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.interfaceText400};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;

  svg {
    width: 19px;
    height: 19px;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    transform: scale(1.02);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    padding: 0 0.875rem;
    font-size: 0.8125rem;
    flex: 1;
    min-width: 0;
    max-width: 100%;
    
    @media (max-width: 420px) {
      padding: 0 0.625rem;
      font-size: 0.75rem;
    }
  }
`;

export const LinkAbrir = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: var(--action-square-bg);
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.pureWhite};
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
        background: var(--action-square-bg-hover);
        color: ${({ theme }) => theme.colors.interfacePure0};
    }
`;

export const PaginationWrapper = styled.div`
    width: 100%;
`;
